// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__24j0e","requiredAsterisk":"Info_requiredAsterisk__1iIza"};